export default __webpack_public_path__ + "static/media/cycles3.2ab02020.png";